/*
 * ॐ नमः शिवाय
 * ಓಂ ನಮಃ ಶಿವಾಯ
 * ఓం నమః శివాయ
 * ஓம் நம சிவாய
 *
 * Copyright (c) 2025 Rudra Coresoft Technologies Private Limited
 *
 * This software is licensed under the VIJAYA 1.0 License.
 *
 * You are free to use, modify, and distribute this software under the terms 
 * of the VIJAYA 1.0 License.
 *
 * MANDATORY ATTRIBUTION:
 * 1. The attribution to Rudra Coresoft Technologies Private Limited in this 
 *    copyright notice must not be removed even after modifications.
 * 2. For Free License usage, the footer phrases "Powered by arcee.io" and 
 *    "Developed by Rudra Coresoft" (plus logos) must remain visible.
 *
 * See the LICENSE file for the full text.
 */

/**
 * ActivityExtras
 * --------------
 * The closing sections of an activity's detail — yoga focus, mood before, how
 * it felt and where it was recorded. Shared by the drawer and
 * the expanded view so both read the same.
 */

import React from 'react';
import FeedIcon from './FeedIcon';
import { /* PRIVACY_LABEL, */ sourceLabel, moodBefore, yogaInfo } from '../../pages/feed/feedModel';

const RPE_WORDS = ['', 'Very easy', 'Easy', 'Easy', 'Moderate', 'Moderate', 'Hard', 'Hard', 'Very hard', 'Very hard', 'Max'];

export default function ActivityExtras({ activity }) {
  return (
    <>
      {activity.type === 'yoga' && yogaInfo(activity).focus.length > 0 && (
        <div className="fd-d-sec">
          <div className="fd-d-sec-h"><span className="fd-eyebrow">Focus areas</span></div>
          <div className="fd-d-tags">{yogaInfo(activity).focus.map((f) => <span key={f}>{f}</span>)}</div>
        </div>
      )}
      {moodBefore(activity) && (
        <div className="fd-d-sec">
          <div className="fd-d-sec-h" style={{ marginBottom: 0 }}><span className="fd-eyebrow">Mood before</span><b style={{ color: 'var(--fd-ink)' }}>{moodBefore(activity)}</b></div>
        </div>
      )}
      {activity.rpe && (
        <div className="fd-d-sec">
          <div className="fd-d-sec-h"><span className="fd-eyebrow">How it felt</span><span><b style={{ color: 'var(--fd-ink)' }}>{activity.rpe}</b> / 10 · {RPE_WORDS[activity.rpe]}</span></div>
          <span className="fd-effort">{Array.from({ length: 10 }, (_, i) => <i key={i} className={i < activity.rpe ? 'on' : undefined} />)}</span>
        </div>
      )}
      {/* Privacy note hidden until the public feed ships — today only the owner sees their activities.
      <div className="fd-d-foot">
        <FeedIcon name={activity.privacy === 'private' ? 'lock' : 'group'} />
        <span><b>{PRIVACY_LABEL[activity.privacy]}</b> — {activity.privacy === 'private' ? 'only you can see this activity.' : 'visibility is set in AthloHive.'}</span>
      </div> */}
      {sourceLabel(activity) && (
        <p style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 14, fontSize: 12, color: 'var(--fd-mute)' }}>
          <FeedIcon name={activity.dataSource ? 'sync' : 'smartphone'} style={{ fontSize: 16 }} />{sourceLabel(activity)}
        </p>
      )}
    </>
  );
}
